import MaturaApplicationPage from "../MaturaApplicationPage/MaturaApplicationPage";
import LumenNavbar from "../../layout/LumenNavbar";
import NewFooter from "../../layout/NewFooter";
import { Container } from "react-bootstrap";

function NewMaturaApplicationPage() {
  return (
    <>
      <LumenNavbar />
      <Container style={{ paddingBottom: "100px" }}>
        <MaturaApplicationPage />
      </Container>
      <NewFooter />
    </>
  );
}

export default NewMaturaApplicationPage;
